import UAParser from 'ua-parser-js';
import * as Cookie from 'tiny-cookie';

const userAgent = navigator.userAgent;
const parserResult = new UAParser(userAgent).getResult();

// 'isMobile' -- additionally check for device type, but do not break the old check logic
export const isMobile =
  Boolean(userAgent.match(/Android|iPhone|Mobile/)) &&
  parserResult.device.type !== 'tablet' &&
  Cookie.get('fullVersion') !== 'true';
export const isAndroid = Boolean(userAgent.match(/Android/));
export const isHasDesktopHover = window.matchMedia('(hover: hover)').matches;
// export const isVeryBadBrowser =
//   parserResult.browser.name?.toLocaleLowerCase().includes('safari') ||
//   parserResult.device.model?.toLocaleLowerCase().includes('ipad');
